import Api from "@/api/apiAxios";
export default {
	channelPushData:{
		pageList:(pageNo:Number,pageSize:Number,params:object)=>Api.postRequest(`/channelPushData/pageList/${pageNo}/${pageSize}`,params), 
        rePush:(id:String)=>Api.getRequest(`/channelPushData/rePush/${id}`), 
	},
};
